import React from 'react';

const TinderCardBanner = (props) => {
  const IS_MOBILE =
    typeof navigator === 'undefined' ||
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i);

  const goToUrl = (e) => {
    e.preventDefault();
    window.location.href = '/pages/rug-swipe';
  };

  const getLocale = () => {
    return localStorage && localStorage.getItem('locale');
  };

  const shop = getLocale();

  if (!IS_MOBILE || shop == 'en-GB') {
    return <React.Fragment />;
  }

  return (
    <div className='swipe-rug-card' onClick={goToUrl}>
      <div className='swipe-rug-card-content'>
        <p className='swipe-rug-card-ttl'>{props.title}</p>
        <p>Swipe through rug styles to choose your perfect match.</p>
        <div className='CtaSecondaryDirectionContainer'>
          <a href='/pages/rug-swipe' className='ctaSecondaryDirectionButton'>
            <span>Start Swiping</span>
            <img
              src='https://cdn.shopify.com/s/files/1/1033/0751/files/SecondaryCTA_Arrow-Right_1.svg?235129'
              className='right-arrow'
              id='ctaSecondaryRight'
              style={{ left: '5px' }}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TinderCardBanner;
